// 定义一个产品配件组件
class MrkProductAccessories extends HTMLElement {
  constructor() {
    super();

    this.element = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.element = this.getElements();

    if (this.element.modelType === 'secondary') {
      this.eventBindSecondary();
      return;
    }

    this.eventBind();
    this.setItems();
  }

  getElements() {
    return {
      containerNode: this.querySelector('.product-accessories-block'),
      modelType: this.getAttribute('model-type')
    }
  }

  eventBind() {
    if (this.element.containerNode) {
      this.element.containerNode.addEventListener('click', (e) => {
        const itemNode = e.target.closest('.item');
        const variantNode = e.target.closest('.variant-option');
        const moreNode = e.target.closest('.more-block');
        const defaultSelected = e.currentTarget.getAttribute('default-selected'); // 有这个属性说明是默认选中的，不能点击
        const aNode = e.target.closest('a');
        if (aNode && aNode.tagName.toLocaleUpperCase() === 'A') return;
        if (moreNode) {
          this.setMore(moreNode)
          return;
        }

        if (defaultSelected === 'true') return;

        if (variantNode) {
          this.setVariant(variantNode);
          return;
        }
        if (itemNode) {
          this.setItme(itemNode);
          return;
        }
      })
    }
  }

  eventBindSecondary() {
    const downBtnAtt = '[down-btn]';
    const downExpandNode = this.querySelector('[down-expand]');
    const downCollapseNode = this.querySelector('[down-collapse]');
    const visibilityItemsNode = this.querySelector('[visibility-items]');
    const downIconNode = this.querySelector('[down-icon]');

    this.addEventListener('click', (e) => {
      const downBtnNode = e.target.closest(downBtnAtt);
      if (downBtnNode && downExpandNode && downCollapseNode) {
        const isOpen = downBtnNode.getAttribute('open');
        if (isOpen) {
          downBtnNode.removeAttribute('open');
          downExpandNode.style.display = '';
          downCollapseNode.classList.add('mrk-none');
          visibilityItemsNode.classList.add('mrk-none');
          downIconNode.style.transform = 'rotate(0deg)';
        } else {
          downBtnNode.setAttribute('open', true);
          downExpandNode.style.display = 'none';
          downCollapseNode.classList.remove('mrk-none');
          visibilityItemsNode.classList.remove('mrk-none');
          downIconNode.style.transform = 'rotate(180deg)';
        }
        return;
      }
    })
  }

  setItems() {
    const itemsNode = this.element.containerNode.querySelector('.accessories-items');
    if (itemsNode) {
      const itemNode = itemsNode.querySelector('.item');
      const itemHeight = itemNode.clientHeight;
      itemsNode.style.setProperty('--items-height', `${itemHeight + 6}px`);
    }
  }

  // 点击更多
  setMore(moreNode) {
    const itemsNode = this.element.containerNode.querySelector('.accessories-items');
    const isOpen = moreNode.getAttribute('open');
    if (isOpen !== null) {
      moreNode.removeAttribute('open');
      itemsNode.classList.add('max-height');
    } else {
      moreNode.setAttribute('open', true);
      itemsNode.classList.remove('max-height');
    }
  }

  // 点击配件列表
  setItme(itemNode) {
    const isChecked = itemNode.getAttribute('checked');
    if (isChecked !== null) {
      itemNode.removeAttribute('checked');
    } else {
      itemNode.setAttribute('checked', true);
    }
  }

  // 点击变体
  setVariant(variantNode) {
    const isChecked = variantNode.getAttribute('checked');
    const optionId = variantNode.getAttribute('data-option-value-id');
    if (!optionId) return;
    if (isChecked !== null) {
      // variantNode.removeAttribute('checked');
    } else {
      const itemFooterNode = variantNode.closest('.item-footer');
      const variantAllNode = itemFooterNode.querySelectorAll('.variant-option');
      variantAllNode.forEach((variantItem) => {
        variantItem.removeAttribute('checked');
      })
      variantNode.setAttribute('checked', true);

      const variantData = this.getVariantData(itemFooterNode, optionId);
      if (variantData) {
        this.setHtml(variantData, variantNode);
      }
    }
  }

  getVariantData(itemFooterNode, optionId) {
    let variantData = itemFooterNode.querySelector(`#product-variant-json-${optionId}`);
    if (variantData) {
      variantData = JSON.parse(variantData.textContent);
      return variantData;
    }
    return null;
  }

  setHtml(variantData, variantNode) {
    const itemNode = variantNode.closest('.item');
    const imageNode = itemNode.querySelector('.media-file');
    const thumbnailIs = imageNode.getAttribute('thumbnail_is');
    const priceNumNode = itemNode.querySelector('.price-num');
    const aNode = itemNode.querySelectorAll('a');
    aNode.forEach((aItem) => {
      aItem.href = variantData.url;
    })
    if (thumbnailIs == 'false' && variantData.featured_image) imageNode.setAttribute('src', variantData.featured_image);
    priceNumNode.textContent = variantData.price;
  }

  disconnectedCallback() {
  }
}
customElements.define("mrk-product-accessories", MrkProductAccessories);

// 产品图片热区
class MrkProductHotspot extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.element = null;

    this.carousel = null;
  }
  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }
  init() {
    this.element = this.getElements();
    this.carousel = this.querySelector('l-mrk-carousel');
    this.bindEvent();
  }
  getElements() {
    return {
      hotspotBtnNodes: this.querySelectorAll('[hotspot-btn]'),
      hotspotCloseNode: this.querySelector('[hotspot-close]'),
      hotspotContentNode: this.querySelector('[hotspot-content]')
    }
  }
  bindEvent() {
    const windowWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    if (windowWidth > 990) {
      this.addEventListener('click', (e) => {
        this.setHotspotBtn(e);
      })
    } else {
      this.addEventListener('touchend', (e) => {
        e.preventDefault();
        this.setHotspotBtn(e, true);
      })
    }

    if (this.element.hotspotCloseNode) {
      this.element.hotspotCloseNode.addEventListener('click', () => {
        this.element.hotspotCloseNode.removeAttribute('open');
        this.element.hotspotContentNode.removeAttribute('open');
      })
    }
  }
  setHotspotBtn(e, isScroll = false) {
    const btn = e.target.closest('[hotspot-btn]');
    const anchorWrap = this.querySelector('[data-anchor-wrap]'); // 锚点容器位置，点击按钮好滚动到对应位置

    if (btn) {
      this.element.hotspotContentNode.setAttribute('open', 'true');
      this.element.hotspotCloseNode.setAttribute('open', '');

      if (anchorWrap && isScroll) {
        const windowScrollTop = window.scrollY || document.documentElement.scrollTop;

        let sectionOffsetTop = 0;
        if (window.merakiUtils && window.merakiUtils.getDocumentTop) {
          sectionOffsetTop = window.merakiUtils.getDocumentTop(anchorWrap);
        }
        if (sectionOffsetTop > 0) {
          if (sectionOffsetTop > windowScrollTop) {
            window.scrollTo({ top: sectionOffsetTop, behavior: 'smooth' });
          }
        }
      }

      if (this.carousel) {
        const btnCurrentIndex = parseFloat(btn.getAttribute('hotspot-btn-index'));
        this.carousel.customSwitch(btnCurrentIndex);
      }
    }
  }
}
customElements.define("mrk-product-hotspot", MrkProductHotspot);

document.addEventListener('DOMContentLoaded', () => {
  // 产品 pdp 页面邮件联系客服，劫持提交事件
  const productEmailUsForm = document.querySelector('#product-email-us-form');
  if (productEmailUsForm) {
    const submitButtonNode = productEmailUsForm.querySelector('.button');
    if (submitButtonNode) {
      submitButtonNode.addEventListener('click', (e) => {
        e.preventDefault();
        const formNode = e.target.closest('form');
  
        const statusSuccessNode = formNode.querySelector('.contact-us-form__success');
        const statusErrorNode = formNode.querySelector('.contact-us-form__errors');
        const statusErrorListNode = formNode.querySelector('.contact-us-form__errors-list');
        const loadingSpinnerNode = formNode.querySelector('.loading__spinner ');
  
        const isFormValid = productEmailUsForm.checkValidity();
        if (!isFormValid) {
          productEmailUsForm.reportValidity();
          return;
        }
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(formNode);
        config.body = formData;
  
        const url = formNode.getAttribute('action');
        if (!url) return;
  
        if (loadingSpinnerNode) loadingSpinnerNode.classList.remove('hidden');
        if (statusSuccessNode) statusSuccessNode.classList.remove('show');
        if (statusErrorNode) statusErrorNode.classList.remove('show');
        if (statusErrorListNode) statusErrorListNode.innerHTML = '';
  
        submitButtonNode.setAttribute('disabled', true);
        fetch(`${url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              let errorHtml = '';
              if (response.msg && typeof response.msg == 'object') {
                for (const key in response.msg) {
                  errorHtml += `<li>${response.msg[key]}</li>`;
                }
              } else {
                errorHtml += `<li>${response.msg}</li>`;
              }
              if (statusErrorListNode) statusErrorListNode.innerHTML = errorHtml;
              if (statusErrorNode) statusErrorNode.classList.add('show');
              return;
            }
            if (statusSuccessNode) statusSuccessNode.classList.add('show');
          })
          .catch((e) => {
            if (statusErrorNode) statusErrorNode.classList.add('show');
          })
          .finally(() => {
            submitButtonNode.removeAttribute('disabled');
            if (loadingSpinnerNode) loadingSpinnerNode.classList.add('hidden');
          });
      })
    }
  }
});